/** @jsxImportSource @emotion/react */
import { FC } from 'react';

import Text from 'components/styled/Text';
import { Flex, Box } from 'components/styled';
import { HrefLink } from 'components/styled/Link';

import { ProfileIconI } from 'assets';

import { EASMultilanguage } from 'utils/EASTypes';
import { useLocalizedMultistring } from 'utils/localization';

export type TContactCard = {
	photo?: string;
	name?: string;
	anotherName?: string;
	email?: string;
	phone?: string;
	position?: EASMultilanguage[];
};

const ContactCard: FC<TContactCard> = ({
	photo,

	name,
	email,
	phone,
	anotherName,
	position,
}) => {
	const localize = useLocalizedMultistring();
	return (
		<Flex bg="white" p={4} flexDirection="column" alignItems="flex-start">
			{photo ? (
				<Box width="100%" mb={4}>
					<img src={photo} alt={`Foto ${name}`} width="100%" />
				</Box>
			) : (
				<Box width="100%" mb={4} backgroundColor="lightgrey" p={5}>
					<ProfileIconI width="100%" height="100%" color="white" />
				</Box>
			)}

			<Text as="h3" mb={1} mt={1} fontWeight="bold" opacity={!name ? 0 : 1}>
				{name ?? '.'}
			</Text>

			{(position ?? []).map(p => (
				<Text
					key={p.CZECH}
					maxWidth={['unset', 'unset', 190]}
					m={0}
					fontSize="sm"
					opacity={!p ? 0 : 1}
				>
					{localize(p) ?? '.'}
				</Text>
			))}
			<Text as="h4" my={1} fontWeight="bold" opacity={!anotherName ? 0 : 1}>
				{anotherName ?? '.'}
			</Text>
			<Flex flexGrow={1} />

			{email && (
				<HrefLink color="secondary" href={`mailto:${email}`}>
					{email}
				</HrefLink>
			)}
			{phone && (
				<HrefLink color="secondary" href={`tel:${phone}`}>
					{phone}
				</HrefLink>
			)}
		</Flex>
	);
};
export default ContactCard;
